const displayType = state => state.displayType;
const offsetY = state => state.offsetY;
const windowWidth = state => state.windowWidth;
const windowHeight = state => state.windowHeight;
const navVisible = state => state.navVisible;
const showCookie = state => state.showCookie;
const contactFormAvailable = state => state.contactFormAvailable;

export default {
    displayType,
    offsetY,
    windowWidth,
    windowHeight,
    navVisible,
    showCookie,
    contactFormAvailable
};


// WEBPACK FOOTER //
// ./src/store/system/getters.js